<header id="page-topbar" style="box-shadow: 0px 0px 0px;">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box" style="background-color: #2d2d2d;">
        <a href="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/l3.png" alt="" height="30">
          </span>
          <span class="logo-lg">
            <img src="assets/images/l2.png" alt="" height="20">
          </span>
        </a>

        <a href="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/l3.png" alt="" height="30">
          </span>
          <span class="logo-lg">
            <img src="assets/images/Restore-Logo.avif" alt="" height="60" width="190" class="mt-2">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-24 header-item waves-effect" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="ri-menu-2-line align-middle"></i>
      </button>

      <!-- App Search-->
      <form class="app-search d-none d-lg-block">
        <div class="position-relative">
          <input type="text" class="form-control" placeholder="{{'HEADER.SEARCH' | translate}}">
          <span class="ri-search-line"></span>
        </div>
      </form>
    </div>

    <div class="d-flex">

      <button class="btn header-item noti-icon waves-effect" routerLink="/support">
        <i class="ri-question-line"></i>
      </button>

      <button class="btn header-item noti-icon waves-effect" routerLink="/task/tasklist">
        <i class="ri-task-line"></i>
      </button>

      <!-- Full screen code start -->
      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon waves-effect" data-toggle="fullscreen"
          (click)="fullscreen()">
          <i class="ri-fullscreen-line"></i>
        </button>
      </div>
      <!-- Full Screen Code End -->

      <!-- Qucik Create Patient code start-->
      <div class="dropdown d-none d-lg-inline-block ms-1" ngbDropdown>
        <button type="button" ngbDropdownToggle class="btn header-item noti-icon waves-effect no-caret"
          id="page-header-quick-dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="ri-add-line"></i>
        </button>

        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="page-header-quick-dropdown">
          <a class="dropdown-item" routerLink="/patientManagement/list"><i class="ri-user-add-line me-1"></i> New
            Patient</a>
          <a class="dropdown-item" href="#"><i class="ri-calendar-check-line me-1"></i> New
            Appointment</a>
          <a class="dropdown-item" routerLink="/billing/invoicesList"><i class="ri-bill-line me-1"></i> New Invoice</a>
        </div>
      </div>
      <!-- Qucik Create Patient code end-->

      <!-- Users chating code start  -->
      <div class="d-inline-block ms-1" ngbDropdown>
        <button type="button" ngbDropdownToggle class="btn header-item noti-icon waves-effect no-caret"
          id="page-header-messages-dropdown" aria-haspopup="true" aria-expanded="false"
          (click)="$event.stopPropagation()">
          <i class="ri-chat-3-line"></i>

          <span class="badge bg-danger rounded-pill" *ngIf="chatUnreadCount > 0">
            {{ chatUnreadCount > 99 ? '99+' : chatUnreadCount }}
          </span>
        </button>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
          aria-labelledby="page-header-messages-dropdown">
          <div class="p-3 border-bottom d-flex align-items-center justify-content-between">
            <h6 class="m-0">Messages</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0"
              (click)="loadChatPreview(); $event.stopPropagation()">
              Refresh
            </button>
          </div>

          <!-- loading -->
          <div class="p-3 text-center" *ngIf="chatPreviewLoading">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
          </div>

          <!-- empty -->
          <div class="p-3 text-center text-muted" *ngIf="!chatPreviewLoading && !chatPreviewThreads.length">
            <div class="small">No recent messages</div>
          </div>

          <!-- list -->
          <div class="p-2" *ngIf="!chatPreviewLoading && chatPreviewThreads.length">
            <button type="button" class="dropdown-item d-flex align-items-center message-preview-item"
              *ngFor="let t of chatPreviewThreads" (click)="openChatFromTopbar(t)">
              <div class="me-2 message-avatar">
                {{ getChatPreviewAvatar(t) }}
              </div>

              <div class="flex-grow-1 min-w-0">
                <div class="d-flex justify-content-between align-items-center gap-2">
                  <span class="fw-semibold text-truncate">
                    {{ getChatPreviewTitle(t) }}
                  </span>

                  <div class="d-flex align-items-center gap-2 flex-shrink-0">
                    <small class="text-muted">
                      {{ getChatPreviewTime(t) }}
                    </small>

                    <span class="badge bg-danger rounded-pill" *ngIf="getUnreadForCurrentUser(t) > 0">
                      {{ getUnreadForCurrentUser(t) }}
                    </span>
                  </div>
                </div>

                <small class="text-muted d-block text-truncate">
                  {{ getChatPreviewText(t) }}
                </small>
              </div>
            </button>

            <div class="text-center p-2 border-top mt-1">
              <a routerLink="/chat" class="btn btn-sm btn-link text-decoration-none">
                View all
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Users chating code end  -->

      <!-- Notifications Dropdown -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" ngbDropdownToggle class="btn header-item noti-icon waves-effect no-caret"
          id="page-header-notifications-dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="ri-notification-3-line"></i>
          <span class="noti-dot" *ngIf="unreadCount > 0"></span>
        </button>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
          aria-labelledby="page-header-notifications-dropdown">
          <!-- Header -->
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ 'HEADER.NOTIFICATIONS.TITLE' | translate }}
                  <span *ngIf="unreadCount > 0" class="badge bg-danger ms-1">
                    {{ unreadCount }}
                  </span>
                </h6>
              </div>
              <div class="col-auto d-flex align-items-center gap-2">
                <button type="button" class="btn btn-sm btn-link p-0" (click)="onMarkAllRead($event)"
                  [disabled]="unreadCount === 0 || notifLoading">
                  <!-- {{ 'HEADER.NOTIFICATIONS.MARK_ALL_READ' | translate }} -->
                  Mark All Read
                </button>
                <a routerLink="/notifications/me" class="small">
                  {{ 'HEADER.NOTIFICATIONS.VIEW_ALL' | translate }}
                </a>
              </div>
            </div>
          </div>

          <!-- List -->
          <ngx-simplebar style="position: relative; height: 260px;">
            <!-- Loading state -->
            <div class="p-3 text-center text-muted" *ngIf="notifLoading">
              <i class="bi bi-arrow-repeat spin me-2"></i>
              Loading notifications...
            </div>

            <!-- Empty state -->
            <div class="p-3 text-center text-muted" *ngIf="!notifLoading && notifications.length === 0">
              <i class="mdi mdi-bell-off-outline d-block mb-2"></i>
              No notifications yet.
            </div>

            <!-- Notification items -->
            <a href="javascript:void(0);" class="text-reset notification-item" *ngFor="let n of notifications"
              (click)="onNotificationClick($event, n)">
              <div class="d-flex">
                <div class="avatar-xs me-3">
                  <span class="avatar-title rounded-circle font-size-16" [ngClass]="{
                'bg-success': n.priority === 'LOW',
                'bg-primary': n.priority === 'NORMAL',
                'bg-warning': n.priority === 'HIGH',
                'bg-danger': n.priority === 'CRITICAL'
              }">
                    <i class="ri-notification-3-line"></i>
                  </span>
                </div>
                <div class="flex-1">
                  <h6 class="mt-0 mb-1" [ngClass]="{ 'fw-bold': !n.isRead }">
                    {{ n.title }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1 text-truncate">
                      {{ n.message || '-' }}
                    </p>
                    <p class="mb-0 d-flex align-items-center">
                      <i class="mdi mdi-clock-outline me-1"></i>
                      <span>
                        {{ n.createdAt | date: 'short' }}
                      </span>
                      <span class="ms-2 badge rounded-pill" [ngClass]="{
                    'bg-soft-success text-success': n.priority === 'LOW',
                    'bg-soft-primary text-primary': n.priority === 'NORMAL',
                    'bg-soft-warning text-warning': n.priority === 'HIGH',
                    'bg-soft-danger text-danger': n.priority === 'CRITICAL'
                  }">
                        {{ n.priority }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </ngx-simplebar>

          <!-- Footer / load more -->
          <div class="p-2 border-top d-flex justify-content-between align-items-center">
            <button class="btn btn-sm btn-link font-size-14 text-start" type="button"
              (click)="onLoadMoreNotifications()" [disabled]="notifLoading || notifPage >= notifTotalPages">
              <i class="mdi mdi-arrow-down-circle-outline me-1"></i>
              {{ 'HEADER.NOTIFICATIONS.LOAD_MORE' | translate }}
            </button>

            <div class="small text-muted me-2">
              Page {{ notifPage }} / {{ notifTotalPages }}
            </div>
          </div>
        </div>
      </div>

      <!--User Setting Code-->
      <div class="dropdown d-inline-block user-dropdown" ngbDropdown>
        <button type="button" ngbDropdownToggle class="btn header-item waves-effect no-caret"
          id="page-header-user-dropdown" aria-haspopup="true" aria-expanded="false">
          <img class="rounded-circle header-profile-user"
            [src]="user?.profileImage || 'https://t4.ftcdn.net/jpg/15/68/51/17/360_F_1568511792_iBQa4ybmLJ4xaLxhNujmCfiJlJVA7axL.jpg'"
            alt="Header Avatar">
          <span class="d-none d-xl-inline-block ms-1">{{ user?.name }}</span>
        </button>


        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a class="dropdown-item" routerLink="/admin/profile"><i class="ri-user-line align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate}}</a>
          <a class="dropdown-item" href="javascript: void(0);"><i class="ri-lock-unlock-line align-middle me-1"></i>
            {{ 'HEADER.LOGIN.LOCK_SCREEN' | translate}}</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" (click)="logout()" style="cursor: pointer;">
            <i class="ri-shut-down-line align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate}}
          </a>
        </div>
      </div>
    </div>
  </div>
</header>









<!-- <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle waves-effect"
          (click)="toggleRightSidebar()">
          <i class="ri-settings-2-line"></i>
        </button>
      </div> -->